import { z } from 'zod'

import { m } from '@/lib/paraglide/messages'

export const SKIP_REASONS = [
    'issued_elsewhere',
    'merged_into_other_order',
    'customer_no_longer_needs',
    'other',
] as const
export type SkipReason = (typeof SKIP_REASONS)[number]

export const SKIP_REASON_LABELS: Record<SkipReason, () => string> = {
    issued_elsewhere: m.einvoice_skip_reason_issued_elsewhere,
    merged_into_other_order: m.einvoice_skip_reason_merged_into_other_order,
    customer_no_longer_needs: m.einvoice_skip_reason_customer_no_longer_needs,
    other: m.einvoice_skip_reason_other,
}

const MAX_NOTE_LENGTH = 500

export function createManualIssueSchema() {
    return z.object({
        inv_series: z.string().trim().min(1, m.einvoice_err_series_required()),
        inv_no: z
            .string()
            .trim()
            .superRefine((value, ctx) => {
                if (value === '')
                    ctx.addIssue({
                        code: 'custom',
                        message: m.einvoice_err_number_required(),
                    })
                else if (!/^[0-9]{1,8}$/.test(value))
                    ctx.addIssue({
                        code: 'custom',
                        message: m.einvoice_err_number_invalid(),
                    })
            }),
        issued_date: z.string().min(1, m.einvoice_err_date_required()),
        delete_old_draft: z.boolean(),
    })
}
export type ManualIssueFormValues = z.infer<
    ReturnType<typeof createManualIssueSchema>
>

export function createSkipSchema() {
    return z
        .object({
            reason: z.enum(SKIP_REASONS, m.einvoice_err_skip_reason_invalid()),
            note: z
                .string()
                .max(MAX_NOTE_LENGTH, m.einvoice_err_note_too_long()),
            delete_old_draft: z.boolean(),
        })
        .superRefine((value, ctx) => {
            if (value.reason === 'other' && value.note.trim() === '')
                ctx.addIssue({
                    code: 'custom',
                    path: ['note'],
                    message: m.einvoice_err_note_required(),
                })
        })
}
export type SkipFormValues = z.infer<ReturnType<typeof createSkipSchema>>
